/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import "./src/css/masthead.css";
import "./src/css/cc.1.css";
import "./src/css/cc.2.css";
import "./src/css/cc.3.css";
import "./src/css/cc.4.css";

import { mseGTM } from "mse-tools-masthead-and-footer/lib/mse-gtm";

if (typeof window !== "undefined") {
  mseGTM();
}
